module.exports = "/assets/site/images/3.png?228656e593b4b03e0d66cd67f94cad0f";